// removed by extract-text-webpack-plugin
module.exports = {"professionalsList":"lj0rOJS4VFVt7woYZAKGL","cardsWrapper":"_2aY9GQhWIdrxJXeelOMduQ","brokerList":"_1i4G80EPUtLME2TgrN3D1Y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfessionalsList/ProfessionalsList.scss
// module id = 1698
// module chunks = 0